import { css } from '@styled-system/css';
import React from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import Tab from '../Tab';
var StyledNav = styled.nav(css({
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    overflowX: 'scroll',
    msOverflowStyle: 'none' /* Hide scrollbar in Internet Explorer / Edge */,
    scrollbarWidth: 'none' /* Hide scrollbar in Firefox */,
    '&::-webkit-scrollbar': {
        display: 'none' /* Hide scrollbar in Chrome, Safari and Opera */,
    },
}), function () {
    return variant({
        variants: {
            primary: {
                maxWidth: null,
            },
            secondary: {
                maxWidth: [null, '75rem', '97rem', '117rem'],
            },
        },
    });
});
var TabsContainer = styled.div(css({
    justifyContent: 'center',
    display: 'flex',
    width: '100%',
}), function (_a) {
    var theme = _a.theme;
    return variant({
        variants: {
            secondary: {
                borderBottom: "0.1rem solid ".concat(theme.colors.grayLightest),
            },
        },
    });
});
var Tabs = function (_a) {
    var tabs = _a.tabs, selectedTab = _a.selectedTab, scrollRef = _a.scrollRef, render = _a.render, onClick = _a.onClick, variant = _a.variant;
    return (React.createElement(TabsContainer, { variant: variant },
        React.createElement(StyledNav, { variant: variant }, tabs.map(function (tab) {
            var _a;
            return (React.createElement(Tab, { key: tab.value, selected: selectedTab === tab.value, href: tab.href, scrollRef: selectedTab === tab.value ? scrollRef : null, onClick: function () {
                    onClick === null || onClick === void 0 ? void 0 : onClick(tab.value, tab.label);
                }, variant: tab.variant, isPrimary: variant === 'primary', render: render, dataTestid: (_a = tab.dataTestid) !== null && _a !== void 0 ? _a : '' }, tab.label));
        }))));
};
export default Tabs;
